import script from "./PixelGame.vue?vue&type=script&setup=true&lang=js"
export * from "./PixelGame.vue?vue&type=script&setup=true&lang=js"

import "./PixelGame.vue?vue&type=style&index=0&id=6a705432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a705432"]])

export default __exports__